import React, { useCallback, useContext, useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Modal,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import NotyfContext from "../../contexts/NotyfContext";
import {
  blankUploadDocument,
  fetchUploadedDocument,
  uploadDocument,
} from "../../redux/slices/UploadDocumentSlice";
import Loader from "../../components/Loader";
import Dropzone from "../../components/dropzone/Dropzone";
import Cropper from "react-easy-crop";
import getCroppedImg from "../../components/cropImage";
import {
  callUserActvity,
  fetchNotification,
  setNotifcationBedge,
} from "../../redux/slices/CommonSlice";
import RotateIcon from "../../assets/img/rotate-solid.svg";
import InfoPopover from "../../components/new/InfoPopover";

const UploadAllDocument = ({setShowDocumentsModal, showDocumentsModal, callbacks, isUpload}) => {
  const notyf = useContext(NotyfContext);
  const dispatch = useDispatch();
  const [generate, setGenerate] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(null);

  const [driverLicenseFile, setDriverLicenseFile] = useState(null);
  const [socialSecurityFile, setSocialSecurityFile] = useState(null);
  const [proofOfAddress, setProofOfAddressFile] = useState(null);

  const uploadDocumentStatus = useSelector(
    (state) => state.uploadDocument.status
  );
  const uploadDocumentData = useSelector(
    (state) => state.uploadDocument.uploadDocumentData
  );
  const uploadDocumentFile = useSelector(
    (state) => state.uploadDocument.uploadDocument
  );
  const error = useSelector((state) => state.uploadDocument.error);


  const [imagePreview, setImagePreview] = useState({
    driverLicense: "",
    socialSecurity: "",
    proofOfAddress: "",
  });
  const [showImageModal, setShowImageModal] = useState({
    show: false,
    type: "",
  });
  const [croppedAreaPixelsID, setCroppedAreaPixelsID] = useState(null);
  const [croppedAreaPixelsSS, setCroppedAreaPixelsSS] = useState(null);
  const [croppedAreaPixelsPOR, setCroppedAreaPixelsPOR] = useState(null);
  const [srcImgID, setSrcImgID] = useState(null);
  const [srcImgSS, setSrcImgSS] = useState(null);
  const [srcImgPOR, setSrcImgPOR] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);

  const showCroppedImageID = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        srcImgID,
        croppedAreaPixelsID,
        rotation
      );
      fetch(croppedImage).then(async (response) => {
        const contentType = response.headers.get("content-type");
        const blob = await response.blob();
        let filename = new Date().valueOf();
        const file = new File([blob], `${filename}.jpg`, { contentType });
        const imagePreviewOri = { ...imagePreview };
        setDriverLicenseFile(file);
        imagePreviewOri.driverLicense = URL.createObjectURL(file);
        setImagePreview(imagePreviewOri);
      });
      setShowImageModal({ show: false, type: "" });
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixelsID]);

  const showCroppedImageSS = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        srcImgSS,
        croppedAreaPixelsSS,
        rotation
      );
      fetch(croppedImage).then(async (response) => {
        const contentType = response.headers.get("content-type");
        const blob = await response.blob();
        let filename = new Date().valueOf();
        const file = new File([blob], `${filename}.jpg`, { contentType });
        const imagePreviewOri = { ...imagePreview };
        setSocialSecurityFile(file);
        imagePreviewOri.socialSecurity = URL.createObjectURL(file);
        setImagePreview(imagePreviewOri);
      });
      setShowImageModal({ show: false, type: "" });
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixelsSS]);

  const showCroppedImagePOR = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        srcImgPOR,
        croppedAreaPixelsPOR,
        rotation
      );
      fetch(croppedImage).then(async (response) => {
        const contentType = response.headers.get("content-type");
        const blob = await response.blob();
        let filename = new Date().valueOf();
        const file = new File([blob], `${filename}.jpg`, { contentType });
        const imagePreviewOri = { ...imagePreview };
        setProofOfAddressFile(file);
        imagePreviewOri.proofOfAddress = URL.createObjectURL(file);
        setImagePreview(imagePreviewOri);
      });
      setShowImageModal({ show: false, type: "" });
    } catch (e) {
      console.error(e);
    }
  }, [croppedAreaPixelsPOR]);

  const onCropCompleteSS = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixelsSS(croppedAreaPixels);
  }, []);

  const onCropCompleteID = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixelsID(croppedAreaPixels);
  }, []);

  const onCropCompletePOR = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixelsPOR(croppedAreaPixels);
  }, []);

  // useEffect(() => {
  //   dispatch(fetchUploadedDocument());
  // }, []);

  useEffect(() => {
    return () => {
      dispatch(blankUploadDocument());
    };
  }, []);

  useEffect(() => {
    if (uploadDocumentData && Object.keys(uploadDocumentData).length > 0) {
      if (uploadDocumentData.error === 0) {
        const basePath = document.body.dataset["app_base_url"];
        setImagePreview({
          driverLicense: uploadDocumentData.response.drivers_license
            ? basePath + uploadDocumentData.response.drivers_license
            : null,
          socialSecurity: uploadDocumentData.response.social_security
            ? basePath + uploadDocumentData.response.social_security
            : null,
          proofOfAddress: uploadDocumentData.response.proof_of_address
            ? basePath + uploadDocumentData.response.proof_of_address
            : null,
        });
      }
    }
  }, [uploadDocumentData]);

  useEffect(() => {
    if (uploadDocumentFile && Object.keys(uploadDocumentFile).length > 0) {
      if (uploadDocumentFile.error == 0) {
        notyf.open({
          type: "success",
          message: "Document uploaded successfully",
          duration: "3000",
          ripple: false,
          dismissible: false,
          position: {
            x: "right",
            y: "top",
          },
        });
        if(generate){
          dispatch(callUserActvity("Docuent uploaded for letters generation"));
          setDriverLicenseFile(null);
          setSocialSecurityFile(null);
          setProofOfAddressFile(null);
          callbacks()
        }else{
          setShowDocumentsModal(false)
        }
        
      } else {
        notyf.open({
          type: "danger",
          message: uploadDocumentFile.msg,
          duration: "3000",
          ripple: false,
          dismissible: false,
          position: {
            x: "right",
            y: "top",
          },
        });
      }
    }
  }, [uploadDocumentFile]);

  const handleSubmitDocument = () => {
    setIsSubmitting(true)
    if (
      ((!driverLicenseFile && !imagePreview.driverLicense) ||
      (!socialSecurityFile && !imagePreview.socialSecurity) ||
      (!proofOfAddress && !imagePreview.proofOfAddress)) && generate 
    ) {
      notyf.open({
        type: "danger",
        message: "All documents are required to generate letters",
        duration: 3000,
        ripple: false,
        dismissible: false,
        position: {
          x: "right",
          y: "top",
        },
      });
      setIsSubmitting(false)
      return;
    } else {
      const obj = {};
      if (driverLicenseFile) obj.drivers_license = driverLicenseFile;
      if (socialSecurityFile) obj.social_security = socialSecurityFile;
      if (proofOfAddress) obj.proof_of_address = proofOfAddress;
      dispatch(uploadDocument(obj));
      dispatch(fetchNotification());
      dispatch(setNotifcationBedge(true));

      setIsSubmitting(false)
    }
  };

  const SUPPORTED_FORMATS = ["jpg", "jpeg", "png", "JPG", "JPEG", "PNG"];

  const onDropID = useCallback((file) => {
    setRotation(0);
    const fileData = file[0];
    const fileExtension = fileData.name.split(".").at(-1);
    if (SUPPORTED_FORMATS.includes(fileExtension)) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setSrcImgID(reader.result));
      reader.readAsDataURL(file[0]);
      setShowImageModal({ show: true, type: "ID" });
    } else {
      notyf.open({
        type: "danger",
        message: "Only png,jpg and jpeg allowed",
        duration: "3000",
        ripple: false,
        dismissible: false,
        position: {
          x: "right",
          y: "top",
        },
      });
    }
  });
  const onDropSS = useCallback((file) => {
    setRotation(0);
    const fileData = file[0];
    const fileExtension = fileData.name.split(".").at(-1);
    if (SUPPORTED_FORMATS.includes(fileExtension)) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setSrcImgSS(reader.result));
      reader.readAsDataURL(file[0]);
      setShowImageModal({ show: true, type: "SS" });
    } else {
      notyf.open({
        type: "danger",
        message: "Only png,jpg and jpeg allowed",
        duration: "3000",
        ripple: false,
        dismissible: false,
        position: {
          x: "right",
          y: "top",
        },
      });
    }
  });
  const onDropPOR = useCallback((file) => {
    setRotation(0);
    const fileData = file[0];
    const imagePreviewOri = { ...imagePreview };
    const fileExtension = fileData.name.split(".").at(-1);
    if (SUPPORTED_FORMATS.includes(fileExtension)) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setSrcImgPOR(reader.result));
      reader.readAsDataURL(file[0]);
      setShowImageModal({ show: true, type: "POR" });
    } else {
      notyf.open({
        type: "danger",
        message: "Only png,jpg and jpeg allowed",
        duration: "3000",
        ripple: false,
        dismissible: false,
        position: {
          x: "right",
          y: "top",
        },
      });
    }
  });


  const handleRotation = () => {
    let rotationOri = rotation;
    rotationOri += 90;
    if (rotation < 360) {
      setRotation(rotationOri);
    } else {
      setRotation(0);
    }
  };

  const basePath = document.body.dataset["app_base_url"];
  if (uploadDocumentStatus === "loading") {
    return <Loader />;
  } else if (uploadDocumentStatus === "failed") {
    notyf.open({
      type: "danger",
      message: error,
      duration: "3000",
      ripple: false,
      dismissible: false,
      position: {
        x: "right",
        y: "top",
      },
    });
  }

  return (
    <React.Fragment>
      <Modal size="xl" show={showDocumentsModal} 
        onHide={() => setShowDocumentsModal(false)}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>&nbsp;</Modal.Header>
        <Modal.Body>
          <Container fluid className="p-0 container-fluid-1335 fifth-step">
            <h3 className="py-4 first-step">
              Please upload your documents here
            </h3>
            <Row>
              <Col md="4" sm="12">
                <Card className="shadow border-0 p-2 mb-3 second-step second-step-two">
                  <Card.Body>
                    <h3>
                      ID{" "}
                      <InfoPopover
                        headerContent={
                          <h3 className="text-center">
                            Acceptable Identification Documents
                          </h3>
                        }
                        bodyContent={
                          <>
                            <ul className="text-start">
                              <li>Copy of driver's license</li>
                              <li>Copy of passport</li>
                              <li>
                                Copies of court documents for legal name change
                              </li>
                              <li>
                                Copy of birth certificate with current name
                              </li>
                              <li>
                                Copy of marriage certificate with current name
                              </li>
                              <li>Copy of military ID</li>
                            </ul>
                          </>
                        }
                      />
                    </h3>
                    <Card className="mb-0">
                      <Dropzone
                        name="ID"
                        onDrop={onDropID}
                        image={imagePreview.driverLicense}
                        accept={"image/*"}
                      />
                    </Card>
                  </Card.Body>
                </Card>
              </Col>
              <Col md="4" sm="12">
                <Card className="shadow border-0 p-2 mb-3 third-step third-step-two">
                  <Card.Body>
                    <h3>
                      Social Security{" "}
                      <InfoPopover
                        headerContent={
                          <h3 className="text-center">
                            Acceptable Social Security Documents
                          </h3>
                        }
                        bodyContent={
                          <>
                            <ul className="text-start">
                              <li>
                                Copy of pay stub with full Social Security
                                number
                              </li>
                              <li>
                                Copy of W-2 form with full Social Security
                                number
                              </li>
                              <li>Copy of a valid Social Security card</li>
                            </ul>
                          </>
                        }
                      />
                    </h3>
                    <Card className="mb-0">
                      <Dropzone
                        name="Social Security"
                        onDrop={onDropSS}
                        image={imagePreview.socialSecurity}
                        accept={"image/*"}
                      />
                    </Card>
                  </Card.Body>
                </Card>
              </Col>
              <Col md="4" sm="12">
                <Card className="shadow border-0 p-2 mb-3 fourth-step fourth-step-two">
                  <Card.Body>
                    <h3>
                      Proof of Address{" "}
                      <InfoPopover
                        headerContent={
                          <h3 className="text-center">
                            Acceptable Proof of Address Documents
                          </h3>
                        }
                        bodyContent={
                          <>
                            <ul className="text-start">
                              <li>
                                Copy of driver’s license or government-issued ID
                                card
                              </li>
                              <li>Copy of Rental/lease agreement</li>
                              <li>Copy of house deed</li>
                              <li>Copy of mortgage or bank statement</li>
                              <li>
                                Copy of utility bill (e.g. electric, gas,
                                telephone)
                              </li>
                              <li>Copy of W-2 form with correct address</li>
                            </ul>
                          </>
                        }
                      />
                    </h3>
                    <Card className="mb-0">
                      <Dropzone
                        name="Proof of Address"
                        onDrop={onDropPOR}
                        image={imagePreview.proofOfAddress}
                        accept={"image/*"}
                      />
                    </Card>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>

          {
            isUpload ? (
              <Button
                variant="primary"
                className="w-md-25 w-50"
                disabled={(
                  (!driverLicenseFile && !imagePreview.driverLicense) ||
                  (!socialSecurityFile && !imagePreview.socialSecurity) ||
                  (!proofOfAddress && !imagePreview.proofOfAddress)
                ) || isSubmitting}
                onClick={() => {setGenerate(false); handleSubmitDocument()}}
              >
            Upload Documents
          </Button>
            ):(<>
              <Button
            onClick={() => {setGenerate(false); handleSubmitDocument()}}
            variant="outline-danger"
            disabled={(
              (!driverLicenseFile && !imagePreview.driverLicense) &&
              (!socialSecurityFile && !imagePreview.socialSecurity) &&
              (!proofOfAddress && !imagePreview.proofOfAddress)
            ) || (
              (driverLicenseFile || imagePreview.driverLicense) &&
              (socialSecurityFile || imagePreview.socialSecurity) &&
              (proofOfAddress || imagePreview.proofOfAddress)
            ) || isSubmitting } 
          >
            Save and Exit
          </Button>

          <Button
            variant="primary"
            className="w-md-25 w-50"
            disabled={(
              (!driverLicenseFile && !imagePreview.driverLicense) ||
              (!socialSecurityFile && !imagePreview.socialSecurity) ||
              (!proofOfAddress && !imagePreview.proofOfAddress)
            ) || isSubmitting}
            onClick={() => {setGenerate(true); handleSubmitDocument()}}
          >
            Generate Letters
          </Button>
            </>)
          }
          
        </Modal.Footer>
      </Modal>
      <style>
        {`
          .dropzone:hover {
            cursor: pointer;
          }
          .dropzone {
            padding: 3rem;
          }
          @media (max-width: 1284px) {
                #progress {
                  width: 980px !important;
                }
              #progress-complete {
                  width: 600px !important;
                }
              }

              @media (max-width: 992px) {
                #progress {
                  width: 980px !important;
                }
              #progress-complete {
                  width: 600px !important;
                }
              }

              @media (max-width: 768px) {
                #progress {
                  width: 980px !important;
                }
              #progress-complete {
                  width: 600px !important;
                }
              }
              .react-joyride__tooltip-container {
                width: 100%;
  max-width: 600px; /* Set the desired width */
}


          `}
      </style>

      <Modal
            show={showImageModal.show}
            onHide={() => setShowImageModal({ show: false, type: "" })}
            backdrop="static"
            keyboard={false}
            size="lg"
          >
            <Modal.Header closeButton>Zoom and Crop Image</Modal.Header>
            <Modal.Body>
              {showImageModal.type === "ID" ? (
                <div style={{ height: "400px", width: "70%" }}>
                  <Cropper
                    image={srcImgID}
                    crop={crop}
                    rotation={rotation}
                    zoom={zoom}
                    // maxZoom={1}
                    // zoomWithScroll={true}
                    // showGrid={true}
                    aspect={16 / 9}
                    onCropChange={setCrop}
                    onRotationChange={setRotation}
                    onCropComplete={onCropCompleteID}
                    onZoomChange={setZoom}
                    // cropSize = {{width:600,height:400}}
                    // objectFit="horizontal-cover"
                  />
                </div>
              ) : null}
              {showImageModal.type === "SS" ? (
                <div style={{ height: "400px", width: "70%" }}>
                  <Cropper
                    image={srcImgSS}
                    crop={crop}
                    rotation={rotation}
                    zoom={zoom}
                    // maxZoom={1}
                    // zoomWithScroll={true}
                    // showGrid={true}
                    aspect={16 / 9}
                    onCropChange={setCrop}
                    onRotationChange={setRotation}
                    onCropComplete={onCropCompleteSS}
                    onZoomChange={setZoom}
                    // cropSize = {{width:600,height:400}}
                    // objectFit="horizontal-cover"
                  />
                </div>
              ) : null}
              {showImageModal.type === "POR" ? (
                <div style={{ height: "400px", width: "70%" }}>
                  <Cropper
                    image={srcImgPOR}
                    crop={crop}
                    rotation={rotation}
                    zoom={zoom}
                    // maxZoom={1}
                    // zoomWithScroll={true}
                    // showGrid={true}
                    aspect={16 / 9}
                    onCropChange={setCrop}
                    onRotationChange={setRotation}
                    onCropComplete={onCropCompletePOR}
                    onZoomChange={setZoom}
                    // cropSize = {{width:600,height:400}}
                    // objectFit="horizontal-cover"
                  />
                </div>
              ) : null}
            </Modal.Body>
            <Modal.Footer>
              <div className="controls">
                <style>{`
            .controls {
  position: unset;
  display: flex;
  flex-direction: column;
  height: 100px;
  justify-content: center;
}
}
            `}</style>
                <label>
                  Zoom Slider
                  <input
                    type="range"
                    value={zoom}
                    min={1}
                    max={3}
                    step={0.1}
                    aria-labelledby="Zoom"
                    onChange={(e) => {
                      setZoom(e.target.value);
                    }}
                    className="zoom-range"
                  />
                </label>

                <br />
                <Button
                  variant="primary"
                  className=" ms-3 mt-md-3 w-100 w-md-75  d-flex align-items-center gap-3 justify-content-center"
                  onClick={() => handleRotation()}
                >
                  <img src={RotateIcon} alt="RotateIcon" width="25" /> Rotate
                  Image
                </Button>
              </div>
            </Modal.Footer>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowImageModal({ show: false, type: "" })}
              >
                Close
              </Button>
              {showImageModal.type === "ID" ? (
                <Button variant="primary" onClick={() => showCroppedImageID()}>
                  Crop and Upload
                </Button>
              ) : showImageModal.type === "SS" ? (
                <Button variant="primary" onClick={() => showCroppedImageSS()}>
                  Crop and Upload
                </Button>
              ) : showImageModal.type === "POR" ? (
                <Button variant="primary" onClick={() => showCroppedImagePOR()}>
                  Crop and Upload
                </Button>
              ) : null}
            </Modal.Footer>
          </Modal>
    </React.Fragment>
  );
};

export default UploadAllDocument;
